<script>
    import { section } from "../store/section.js";

    import { token } from "../store/token.js";
    import { active_workspace } from "../store/workspace.js";
    import { active_subscription } from "../store/subscription.js";

    import { fetch_workspace_member_list } from "../api/request.js";
    import HeadingContent from "./component/HeadingContent.svelte";

    const STORAGE_ADDON_TO_READABLE_TITLE_MAPPING = {
        undefined: "250 GB",
        "1-tb-storage-yearly": "1 TB",
        "2-tb-storage-yearly": "2 TB",
        "5-tb-storage-yearly": "5 TB",
    };

    const set_section = (selected_section) => {
        section.set(selected_section);
    };

    console.log($active_subscription);
    console.log($active_workspace);
</script>

<div class="settings-holder settings-active">
    <!-- Settings Billing Plan Paid (Second Level)-->
    <div class="settings-holder-content content-active">
        <HeadingContent
            title="Plan overview"
            back_button_enabled={true}
            back_button_click_action={() => {
                set_section("account/workspaces/overview/billing");
            }}
        />
        <!--
        <div class="settings-heading">
            <div
                class="heading-block"
                on:click={() => {
                    set_section("account/workspaces/overview/billing");
                }}
            >
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title">Plan overview</strong>
                    </div></a
                >
            </div>
        </div>
        -->
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div
                        class="card-settings-main card-join-bottom card bg-transparent-mobile"
                    >
                        <div class="card-body">
                            <nav>
                                <ul class="nav-second-level nav-settings">
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Your plan</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        You are
                                                                        on the
                                                                        {$active_subscription
                                                                            .readable_short_title_mapping[
                                                                            $active_subscription
                                                                                .plan_id
                                                                        ]}
                                                                        plan
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >{$active_workspace.title}
                                                                    Seat usage</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    {#await fetch_workspace_member_list($active_workspace.string_id, $token)}
                                                                        <p>
                                                                            Loading
                                                                            seats
                                                                            information
                                                                        </p>
                                                                    {:then member_list}
                                                                        <p>
                                                                            {member_list.length ||
                                                                                0}
                                                                            of {$active_subscription.plan_quantity}
                                                                            users
                                                                        </p>
                                                                    {/await}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Storage
                                                                    usage</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        {Math.round(
                                                                            ($active_workspace
                                                                                .info
                                                                                .storage
                                                                                .segment_size_gb +
                                                                                Number.EPSILON) *
                                                                                100,
                                                                        ) / 100}
                                                                        of
                                                                        {$active_workspace
                                                                            .info
                                                                            .storage_limit_gb}
                                                                        GB
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="col-auto"
                                                            >
                                                                <div
                                                                    class="links-opener"
                                                                >
                                                                    <div
                                                                        class="df-row df-aic gx-3"
                                                                    >
                                                                        <div
                                                                            class="col-auto"
                                                                        >
                                                                            <a
                                                                                href="#"
                                                                                >Manage
                                                                                plan</a
                                                                            >
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <div
                    class="card-settings-main-footer card bg-transparent-mobile"
                >
                    <div class="card-body">
                        <div class="df-row df-aic df-md-jce gx-1">
                            <div class="col-md-auto">
                                <a
                                    class="btn btn-primary"
                                    on:click={() => {
                                        set_section(
                                            "account/workspaces/overview/change_plan",
                                        );
                                    }}
                                    href="#">Change Plan</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Settings Billing Payment Methods (Second Level)-->
    <div class="settings-holder-content">
        <div class="settings-heading">
            <div
                class="heading-block"
                on:click={() => {
                    set_section("account/workspaces/overview/billing");
                }}
            >
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title">Plan overview</strong>
                    </div></a
                >
            </div>
        </div>
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div
                        class="card-settings-main card-join-bottom card bg-transparent-mobile"
                    >
                        <div class="card-body">
                            <nav>
                                <ul class="nav-second-level nav-settings">
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Card
                                                                    information</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        American
                                                                        Express
                                                                        ending
                                                                        in 5678
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Invoice
                                                                    Settings</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        Update
                                                                        your
                                                                        company
                                                                        info
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <div
                    class="card-settings-main-footer card bg-transparent-mobile"
                >
                    <div class="card-body">
                        <div class="df-row df-aic df-md-jce gx-1">
                            <div class="col-md-auto">
                                <a class="btn btn-dark" href="#"
                                    >Edit Invoice Information</a
                                >
                            </div>
                            <div class="col-md-auto">
                                <a class="btn btn-primary" href="#"
                                    >Update Card</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
